import { Injectable, isDevMode } from '@angular/core';
import { EMPTY } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { map } from 'rxjs/internal/operators/map';
import { UserService } from '../../user-service/user.service';
import { DashboardCenter } from 'src/app/models/dashboard-models/dasboard-center.model';
import { DashboardDaoService } from 'src/app/dao/dashboard-dao-service/dashboard-dao.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';
import { DashboardDeviceStatus } from 'src/app/models/dashboard-models/dasboard-device-status.model';

@Injectable({
  providedIn: 'root'
})
export class DashboardDeviceService {

  constructor(
    private userService: UserService,
    private userStorageService: UserStorageService,
    private dashboardDaoService: DashboardDaoService
  ) { }

  public getCenters() {
    return this.dashboardDaoService.getCenters(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      this.userStorageService.getUDID()
    ).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const centers = new Array<DashboardCenter>();
        o['data']['centers'].forEach(
          (item) => {
            const center = new DashboardCenter();
            Object.assign(center, item);
            centers.push(center);
          }
        );
        return centers;
      })
    );
  }

  public getDevicesByStatus() {
    return this.dashboardDaoService.getCenterDevicesByStatus(
      this.userStorageService.getContext(),
      this.userStorageService.getLang(),
      this.userStorageService.getUDID()
    ).pipe(
      tap(o => !isDevMode() || console.dir(o)),
      map(o => {
        const devices = new Array<DashboardDeviceStatus>();
        o['data']['result'].forEach(
          (item) => {
            const center = new DashboardDeviceStatus();
            Object.assign(center, item);
            devices.push(center);
          }
        );
        return devices;
      })
    );
  }

}
